import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { Container, Grid } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => {
  return {
    typoCasestudyfont1: {
      fontFamily: "Rubik",
      fontWeight: 500,
      color: "black",
      //   fontSize: 18,
    },
    typoCasestudyfont2: {
      fontFamily: "Rubik",
      fontWeight: 300,
      color: "#757575",
      //   fontSize: 18,
    },
    typoText: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 300,
      //   fontSize: 18,
    },
    typoTextRight: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 300,
      //   fontSize: 18,
      textAlign: "right",
    },
    typoHeadline: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 700,
    },
    typoSubheadline: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 500,
    },
    image: {
      "&:hover": {
        opacity: "0.5",
        transition: "ease-in-out",
        transitionDuration: "0.2s",
      },
    },
    but: {
      fontSize: 20,
    },
  };
});

export default function Modal(props) {
  //   const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={props.open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar
          sx={{ position: "relative", backgroundColor: "#fff" }}
          elevation={0}
        >
          <Toolbar>
            <IconButton edge="start" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Container>
          <Grid container justifyContent="center">
            <Grid item>
              <Typography variant="h6" className={classes.typoText}>
                Coming Soon !
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Dialog>
    </div>
  );
}
